import { Input } from "@/components/ui/input";
import { curSym } from "@/lib/company";

/**
 * Fiyat girişi — solda sabit sistem para birimi göstergesi ile.
 * Drop-in: mevcut <Input type="number" .../> yerine <PriceInput type="number" .../> kullan.
 */
export function PriceInput({ className = "", wrapperClassName = "", ...props }) {
  return (
    <div className={`relative ${wrapperClassName}`}>
      <span className="pointer-events-none absolute left-2.5 top-1/2 z-10 -translate-y-1/2 text-sm font-semibold text-slate-500">{curSym()}</span>
      <Input {...props} className={`pl-7 ${className}`} />
    </div>
  );
}

export default PriceInput;
